
import { Map, Record } from 'immutable';
import { StockStatusListResponseModel } from '../stock-model/stockstatuslist.response.model';

export interface StockState extends Map<string, any> {
  stockList: Array<StockStatusListResponseModel>;
  newStockList: any;
  stockListCount: any;
  stockUpdate: any;
  stockdelete: any;

  listLoading: boolean;
  listLoaded: boolean;
  listFailed: boolean;

  countLoading: boolean;
  countLoaded: boolean;
  countFailed: boolean;

  addLoading: boolean;
  addLoaded: boolean;
  addFailed: boolean;

  updatLoading: boolean;
  updatLoaded: boolean;
  updatFailed: boolean;

  updateLoading: boolean;
  updateLoaded: boolean;
  updateFailed: boolean;

  deleteLoading: boolean;
  deleteLoaded: boolean;
  deleteFailed: boolean;
}

export const StockRecordState = Record({
  stockList: {},
  newStockList: {},
  stockListCount: {},
  stockUpdate: {},
  stockdelete: {},

  listLoading: false,
  listLoaded: false,
  listFailed: false,

  countLoading: false,
  countLoaded: false,
  countFailed: false,

  addLoading: false,
  addLoaded: false,
  addFailed: false,

  updatLoading: false,
  updatLoaded: false,
  updatFailed: false,

  updateLoading: false,
  updateLoaded: false,
  updateFailed: false,

  deleteLoading: false,
  deleteLoaded: false,
  deleteFailed: false
});
